var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer position-absolute"},[_c('div',{staticClass:"row g-0 justify-content-between align-items-center h-100"},[_c('div',{staticClass:"col-12 col-sm-auto text-center"}),_c('div',{staticClass:"col-12 col-sm-auto text-center"},[_c('p',{staticClass:"mb-0 text-600"},[_vm._v("Bank "+_vm._s(new Date().getFullYear())+" ©")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }